// extracted by mini-css-extract-plugin
module.exports = {"root":"_2672bb","icon":"_dd68ea","teal":"_70562c","grey":"_b875bd"};